module.exports = __webpack_public_path__ + "static/media/stand-in-icn.0b383a1a.png";